export const MANG_DON_VI_FIELDS = [
  {
    field: "Stt",
    header: "STT",
    bodyClass: "text-center"
  },
  {
    field: "donVi",
    header: "Đơn vị",
    keySearch: "donVi"
  },
  {
    field: "chucVu",
    header: "Chức vụ",
    keySearch: "chucVu"
  },
  {
    field: "trangThai",
    header: "Trạng thái",
    keySearch: "trangThai",
    headerStyle: "width: 150px",
    bodyClass: "text-center"
  },
  {
    field: "macDinh",
    header: "Mặc định",
    headerStyle: { width: '100px' },
    bodyClass: "text-center"
  },
  {
    field: "isShowTreeCCTC",
    header: "Hiển thị cơ cấu tổ chức",
    headerStyle: { width: '100px' },
    bodyClass: "text-center"
  },
  {
    field: "bit_LanhDaoDonVi",
    header: "Lãnh đạo đơn vị",
    headerStyle: "width: 100px",
    bodyClass: "text-center"
  },
  {
    field: "thaoTac",
    header: "Thao tác",
    headerStyle: "width: 50px",
    bodyClass: "text-center"
  },
];

export const MANG_THONG_TIN_TAI_KHOAN_FIELDS = [
  {
    field: "Stt",
    header: "STT",
    bodyClass: "text-center"
  },
  {
    field: "tenDangNhap",
    header: "Tên đăng nhập",
    keySearch: "tenDangNhap1"
  },
  {
    field: "ungDung",
    header: "Ứng dụng",
    keySearch: "ungDung1"
  },
  {
    field: "trangThai",
    header: "Trạng thái",
    headerStyle: "width: 150px",
    keySearch: "trangThai1",
    bodyClass: "text-center"
  },
  {
    field: "thaoTac",
    header: "Thao tác",
    headerStyle: "width: 50px",
    bodyClass: "text-center"
  },
];
